




































































































import { Component, Prop, PropSync, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  Col,
  DataTable,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { orderBy } from 'lodash'
import { systemCodeApi, SystemCodeWithKey } from '@/api'
import { InputCode } from '@/components/molecules/InputCode'
import { CODE_KEY } from '@/config'
import { MaskPattern, SortOrder, UserDetailStateInfo } from '@/types'
import { systemCodeStore } from '@/store'

const COLS: Col[] = [
  {
    width: 80,
    items: [
      {
        name: 'reserve',
        align: 'center',
        headerText: '予約'
      }
    ]
  },
  {
    width: 80,
    items: [
      {
        name: 'newArrival',
        align: 'center',
        headerText: '新着連絡'
      }
    ]
  },
  {
    width: 80,
    items: [
      {
        name: 'remind',
        align: 'center',
        headerText: '督促連絡'
      }
    ]
  },
  {
    width: 80,
    items: [
      {
        name: 'notice',
        align: 'center',
        headerText: 'お知らせ'
      }
    ]
  },
  {
    width: 80,
    items: [
      {
        name: 'event',
        align: 'center',
        headerText: 'イベント'
      }
    ]
  },
  {
    width: 40,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '100',
    items: [
      {
        name: 'address',
        headerText: 'メールアドレス',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: 160,
    items: [
      {
        name: 'type',
        headerText: 'メール区分',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: 30,
    items: [
      {
        name: 'remove',
        align: 'center'
      }
    ]
  }
]

export interface UserMailAddressTableItem {
  id: number
  address: {
    input: string
    errorMessage: string
  }
  reserve: boolean
  newArrival: boolean
  remind: boolean
  notice: boolean
  event: boolean
  type: {
    input: string
    display: string
    errorMessage: string
  }
}

export const defaultUserMailAddressTableItem = (): UserMailAddressTableItem => ({
  id: 0,
  address: {
    input: '',
    errorMessage: ''
  },
  reserve: systemCodeStore.defaultMailContactReserve,
  newArrival: systemCodeStore.defaultMailContactNewArrival,
  remind: systemCodeStore.defaultMailContactRemind,
  notice: systemCodeStore.defaultMailContactNotice,
  event: systemCodeStore.defaultMailContactEvent,
  type: {
    input: '',
    display: '',
    errorMessage: ''
  }
})

@Component({
  components: {
    InputCode,
    DataTable
  }
})
export default class UserMailAddressTable extends ComponentVue {
  @PropSync('items', {
    type: Array,
    required: true
  })
  inputItems!: UserMailAddressTableItem[]

  @Prop({
    type: Object,
    required: true
  })
  state!: UserDetailStateInfo

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  sortName: string = ''

  sortOrder: SortOrder = ''

  get halfWidthOnlyMask(): string {
    return MaskPattern.HalfWidthOnly
  }

  get sortedInputItems(): UserMailAddressTableItem[] {
    if (this.sortName) {
      return orderBy<UserMailAddressTableItem>(
        this.inputItems,
        (item: UserMailAddressTableItem) => {
          switch (this.sortName) {
            case 'address':
              return item.address.input
            case 'type':
              return item.type.display
          }
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.inputItems
  }

  get mailTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.MAIL_TYPE.KEY)
  }

  get allCols(): Col[] {
    if (this.state.isCreateOrUpdate()) {
      return COLS.map(col => {
        return {
          width: col.width,
          items: col.items.map(item => {
            return {
              name: item.name,
              headerText: item.headerText,
              align: item.align,
              sortable: false,
              sortOrder: item.sortOrder,
              lineFeed: item.lineFeed
            }
          })
        }
      })
    }

    return COLS
  }

  get cols(): Col[] {
    if (this.state.isCreateOrUpdate()) {
      return this.allCols
    }
    return this.allCols.filter((item: Col) => {
      return item.items[0].name !== 'remove'
    })
  }

  @Watch('state.state')
  onChangeState(): void {
    this.onSort({
      name: '',
      order: ''
    })
  }

  add(): void {
    this.inputItems.push(defaultUserMailAddressTableItem())
  }

  remove(index: number): void {
    this.inputItems.splice(index, 1)
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }
}
